// extracted by mini-css-extract-plugin
export default {"Container":"ErrorPasswordExceeded_Container__TauEq","profileIcon":"ErrorPasswordExceeded_profileIcon__ck-IK","paraWrapper":"ErrorPasswordExceeded_paraWrapper__kKzzy"};